module.exports = __webpack_public_path__ + "4e1331d295f5b9fdcbb2615e2d41cf1b.pdf";